// Requests to OUR API carry the HttpOnly session cookie (security policy, Phase 8).
// The cookie is set by the API at login and can't be read by JavaScript; the server
// checks it together with the Bearer token. Only URLs under the API base get
// credentials — other websites (maps, uploads, translations…) are never sent it.
// Same file in the admin app, HRMS, kanban and PWA.
let installed = false;

export const installApiCredentials = (axiosInstance, baseUrl) => {
  const base = String(baseUrl || "").replace(/\/+$/, "");
  if (!base || installed) return;
  installed = true;
  const own = (url) => {
    const u = String(url || "");
    return u === base || u.startsWith(`${base}/`) || u.startsWith(`${base}?`);
  };

  // axios (XHR): withCredentials, so the browser sends — and at login stores — the cookie
  axiosInstance.interceptors.request.use((config) => {
    const url = config.baseURL && !/^https?:\/\//i.test(config.url || "")
      ? `${String(config.baseURL).replace(/\/+$/, "")}/${String(config.url || "").replace(/^\/+/, "")}`
      : config.url;
    if (own(url)) config.withCredentials = true;
    return config;
  });

  // fetch: credentials "include" for our API only (keepalive logout, idle timer, re-auth…)
  if (typeof window !== "undefined" && window.fetch && !window.fetch.__buCredentials) {
    const original = window.fetch.bind(window);
    const patched = (input, init) => {
      const url = typeof input === "string" || input instanceof URL ? String(input) : input && input.url;
      if (own(url) && !(init && init.credentials)) init = { ...(init || {}), credentials: "include" };
      return original(input, init);
    };
    patched.__buCredentials = true;
    window.fetch = patched;
  }
};
